'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initHeader = initHeader;
exports.setClassNameHeader = setClassNameHeader;
// Action types
var INIT_HEADER = exports.INIT_HEADER = 'INIT_HEADER';
var UPDATE_CLASS_HEADER = exports.UPDATE_CLASS_HEADER = 'UPDATE_CLASS_HEADER';

function initHeader() {
    var headerInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isActive: true };

    return function (dispatch) {
        return dispatch({
            type: INIT_HEADER,
            headerInfo: headerInfo
        });
    };
}

function setClassNameHeader() {
    var classHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function (dispatch) {
        return dispatch({
            type: UPDATE_CLASS_HEADER,
            classHeader: classHeader
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/header.js
// module id = 776
// module chunks = 0